























import { Vue, Component, Prop } from 'vue-property-decorator';

import CabeceraModal from '@/reusable/Modal/CabeceraModal.vue';

@Component({
  components: {
    CabeceraModal,
  },
})
export default class CabeceraModalDevolucionVista extends Vue {
  @Prop({ default: true }) mostrarBtnVolver: Boolean;
  @Prop({ default: true }) mostrarBtnContinuar: Boolean;

  cont() {
    this.$emit('continuarVer');
  }
  volv() {
    this.$emit('volverVer');
  }
}
